import { h } from "preact";
import { Alert, Box, Grid, Paper, Stack, Typography } from "@mui/material";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";

import { makeStyles } from "@mui/styles";

import dayjs from "dayjs";
import "dayjs/locale/fr";
var utc = require('dayjs/plugin/utc')
var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);
dayjs.locale("fr");
dayjs.extend(utc);
const useStyles = makeStyles({
	message: {
		width: "100%",
	},
});

export default function EventsTimeLineCard({ events }) {
	``
	const classes = useStyles();
	return (
		<Paper style="padding: 10px; height: 100%;">
			<Box
				display="flex"
				justifyContent="space-between"
				alignItems="flex-start"
			>
				<Box style="width: 100%;" >
					<Typography variant="h5" style="width: 100%; border-bottom: 1px solid rgb(234, 234, 234);">Votre actualité</Typography>
				</Box>
			</Box>
			<div style="height: 450px; overflow-x: hidden;  overflow-y: auto;">
				<Timeline position="alternate">
					{events &&
						events.map((ev) => {
							return (
								<TimelineItem>
									<TimelineOppositeContent>
										<Typography color="textSecondary">{dayjs(ev.d + "Z").utc().utcOffset(120).fromNow()}</Typography>
									</TimelineOppositeContent>
									<TimelineSeparator>
										<TimelineDot variant="outlined" color="primary" />
										<TimelineConnector />
									</TimelineSeparator>
									<TimelineContent>
										<Alert
											severity={
												ev.s === 0 ? "info" : ev.s === 1 ? "success" : ev.s === 2 ? "warning" : ev.s === 3 ? "error" : "info"
											}
											style="width: 100%"
											icon={false}
											classes={classes}
										>
											<Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} spacing={1} style="width: 100%">
												{ev.t}
												{ev.a && ev.a !== null ? <ArrowCircleRightIcon onClick={() => { window.location.href = ev.a }} /> : null}
											</Stack>
										</Alert>
									</TimelineContent>
								</TimelineItem>
							);
						})}
				</Timeline>
			</div>
		</Paper>
	);
}
//<Arrow />